import { gql, useQuery } from "@apollo/client";

export function useUserQuestionnairesAnswers() {
  return useQuery(gql`
    query getUserQuestionnaireAnswers {
      user_questionnaire_answers {
        _id
        name
        answers {
          _id
          label
          answer_id
        }
      }
    }
  `);
}
